/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 09:46:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 17:42:47
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { TAHManagementList } from './TAHManagement/TAHManagement'
import { TAHLocationList } from './TAHLocation/TAHLocation'
import { TAHSearchRecordList } from './TAHSearchRecord/TAHSearchRecord'

export const TemperatureAndHumidityRecordTabs = (): ReactElement => {
  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState<any>('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={
        location.state ? location.state.selectKey : selectKey || '0'
      }
      onChange={(v) => {
        setSelectKey(v)
      }}
    >
      <TabPane key='0' tab='温湿度管理'>
        <TAHManagementList selectKey={selectKey}></TAHManagementList>
      </TabPane>
      <TabPane key='1' tab='温湿度-位置'>
        <TAHLocationList selectKey={selectKey}></TAHLocationList>
      </TabPane>
      <TabPane key='2' tab='温湿度记录查询'>
        <TAHSearchRecordList selectKey={selectKey}></TAHSearchRecordList>
      </TabPane>
    </TabBar>
  )
}
